import { FC, HTMLAttributes } from 'react';

import { imgBox } from '@/styles/components/boxes.module.scss';

export const GalleriesItem: FC<
  HTMLAttributes<HTMLDivElement>
> = ({ children, ...props }) => {
  return (
    <div className={imgBox} {...props}>
      {children}
    </div>
  );
};
